import * as React from 'react';

function Futsal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M17 18l3 2V4H4v16l3-2"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9c-.86 0-1.637.362-2.184.943L12 11.4l2.184-1.456A2.992 2.992 0 0012 9zm2.74 1.775l-2.24 1.493v2.69a3 3 0 002.24-4.183zM9 12c0-.436.093-.851.26-1.225l2.24 1.493v2.69A3 3 0 019 12zm-2 0a5 5 0 1110 0 5 5 0 01-10 0z"
        fill="currentColor"
      />
    </svg>
  );
}
export default Futsal;
